import { useState } from 'react'
import { Link, NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { tieneRol } from '../auth/roles'
import { t } from './i18n'
import { LangSelect, useLang } from '../i18n/LangProvider'
import styles from './AdminLayout.module.css'
import ukeLogo from '../assets/escudo-uke.png'

export function AdminLayout() {
  const { user, logout } = useAuth()
  const esAdmin = tieneRol(user, 'admin')
  const tieneOtroRol = tieneRol(user, 'director', 'coordinador', 'entrenador')
  const lang = useLang()
  const [menuOpen, setMenuOpen] = useState(false)

  function closeMenu() {
    setMenuOpen(false)
  }

  return (
    <>
      <div className={styles.layout}>
        <header className={styles.topbar}>
          <button className={styles.hamburger} aria-label="ireki-menua" onClick={() => setMenuOpen(true)}>
            ☰
          </button>
          <Link to="/" aria-label="UKE Gara">
            <img className={styles.topbarLogo} src={ukeLogo} alt="UKE Gara" />
          </Link>
          <div className={styles.topbarActions}>
            {/* Feedback de navegación, 2026-10-02: "el idioma siempre arriba... a la izquierda
                aunque haya botones" — antes el selector de idioma solo estaba en el menú lateral
                (oculto tras la hamburguesa), no en la barra superior siempre visible. */}
            <LangSelect className={styles.langSelectTopbar} />
            {user && (
              <span className={styles.userBadge}>
                {user.nombre_visible ?? user.email} ({user.roles?.join(', ')})
              </span>
            )}
            <button className={styles.logoutButton} onClick={() => logout()}>
              {t('salir', lang)}
            </button>
          </div>
        </header>

        {menuOpen && <div className={styles.overlay} onClick={closeMenu} />}

        {/* Look & feel (club, 2026-10-23: "el menú de la izquierda… igual tenemos que darle una
            vuelta"): cabecera con escudo y nombre, opciones con icono agrupadas en «Aplicación» y
            «Backoffice», y la opción activa en verde con el mismo relieve que los botones. */}
        <nav className={`${styles.nav} ${menuOpen ? styles.navOpen : ''}`}>
          <div className={styles.navHeader}>
            <Link to="/" className={styles.navBrand} onClick={closeMenu}>
              <img className={styles.navLogo} src={ukeLogo} alt="" />
              <span className={styles.navBrandText}>
                <strong>UKE Gara</strong>
                <small>{t('navBackoffice', lang)}</small>
              </span>
            </Link>
            <button className={styles.closeButton} aria-label="itxi-menua" onClick={closeMenu}>
              ✕
            </button>
          </div>
          <LangSelect className={styles.langSelect} />
          {(tieneOtroRol || esAdmin) && <span className={styles.navSection}>{t('navAplicacion', lang)}</span>}
          {tieneOtroRol && (
            <Link to="/" onClick={closeMenu}>
              <span aria-hidden className={styles.navIcon}>⚽</span>
              {t('irAEquipoak', lang)}
            </Link>
          )}
          {esAdmin && (
            <Link to="/panel" onClick={closeMenu}>
              <span aria-hidden className={`${styles.navIcon} icon-alerta`}>{'\u26A0\uFE0E'}</span>
              {t('irAPanel', lang)}
            </Link>
          )}
          <span className={styles.navSection}>{t('navBackoffice', lang)}</span>
          {esAdmin && (
            <>
              <NavLink
                to="/admin/usuarios"
                className={({ isActive }) => (isActive ? styles.active : undefined)}
                onClick={closeMenu}
              >
                <span aria-hidden className={styles.navIcon}>👤</span>
                {t('usuarios', lang)}
              </NavLink>
              <NavLink
                to="/admin/temporadas"
                className={({ isActive }) => (isActive ? styles.active : undefined)}
                onClick={closeMenu}
              >
                <span aria-hidden className={styles.navIcon}>📅</span>
                {t('temporadas', lang)}
              </NavLink>
              <NavLink
                to="/admin/equipos"
                className={({ isActive }) => (isActive ? styles.active : undefined)}
                onClick={closeMenu}
              >
                <span aria-hidden className={styles.navIcon}>👕</span>
                {t('equipos', lang)}
              </NavLink>
              {/* Petición del club (2026-10-31): estadísticas de uso, rendimiento y fallos. */}
              <NavLink
                to="/admin/uso"
                className={({ isActive }) => (isActive ? styles.active : undefined)}
                onClick={closeMenu}
              >
                <span aria-hidden className={styles.navIcon}>📊</span>
                {t('usoEstado', lang)}
              </NavLink>
            </>
          )}
          <NavLink
            to="/admin/historico"
            className={({ isActive }) => (isActive ? styles.active : undefined)}
            onClick={closeMenu}
          >
            <span aria-hidden className={styles.navIcon}>🗂</span>
            {t('historico', lang)}
          </NavLink>
          {/* Petición del club (2026-10-31): manual de usuario accesible desde la app. */}
          <Link to="/ayuda" onClick={closeMenu}>
            <span aria-hidden className={styles.navIcon}>❓</span>
            {t('ayuda', lang)}
          </Link>
          <div className={styles.navFooter}>
            {user && <span className={styles.userBadge}>{user.nombre_visible ?? user.email}</span>}
            <button className={styles.drawerLogoutButton} onClick={() => logout()}>
              {t('salir', lang)}
            </button>
          </div>
        </nav>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </>
  )
}
